export const Header = () => {
  return (
    <header>
      <h1>総人口推移グラフ</h1>
    </header>
  );
};
